import { 
  CollectionSiteRequest, 
  UpdateCollectionSiteRequest, 
  CollectionSiteQueryParams,
} from '../types/collection-site.type';
import { HttpMethods, makeRequest } from '../helpers/http.helper';

export const getCollectionSites = (params: CollectionSiteQueryParams) => {
  const { organization_id, ...otherParams } = params;
  return makeRequest({
    url: `/collection_site/${organization_id}`,
    method: HttpMethods.GET,
    params: otherParams,
  });
};

export const getCollectionSite = (siteId: string) => {
  return makeRequest({
    url: `/collection_site/${siteId}`,
    method: HttpMethods.GET,
  });
};

export const createCollectionSite = (site: CollectionSiteRequest) => {
  return makeRequest({
    url: '/collection_site',
    method: HttpMethods.POST,
    data: site,
  });
};

export const updateCollectionSite = (siteId: string, site: UpdateCollectionSiteRequest) => {
  return makeRequest({
    url: `/collection_site/${siteId}`,
    method: HttpMethods.PUT,
    data: site,
  });
};

export const deleteCollectionSite = (siteId: string) => {
  return makeRequest({
    url: `/collection_site/${siteId}`,
    method: HttpMethods.DELETE,
  });
}; 